module.exports = __webpack_public_path__ + "assets/voltaje.3c22947d3e74552662b1cf7f5876be29.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/voltaje.png
// module id = 887
// module chunks = 0